var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buildserviceMovie",attrs:{"data-nosnippet":"true"}},[_c('iframe',{staticClass:"buildserviceMovie_src",attrs:{"src":"https://www.youtube.com/embed/QsKNcvKASrE","loading":"lazy","frameborder":"0"}})])
}]

export { render, staticRenderFns }